
import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface Guest {
  id: string;
  nombre: string;
  tel: string;
  estado: string;
  fecha_respuesta: string | null;
}

interface EditGuestModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  guest: Guest | null;
  onSave: (guest: Guest) => void;
}

export const EditGuestModal: React.FC<EditGuestModalProps> = ({ 
  open, 
  onOpenChange, 
  guest,
  onSave 
}) => {
  const [nombre, setNombre] = useState('');
  const [tel, setTel] = useState('');
  const [estado, setEstado] = useState('PENDIENTE');

  useEffect(() => {
    if (guest) {
      setNombre(guest.nombre);
      setTel(guest.tel);
      setEstado(guest.estado);
    }
  }, [guest]);

  const handleSave = () => {
    if (guest && nombre && tel) {
      onSave({
        ...guest,
        nombre,
        tel,
        estado
      });
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Editar Invitado</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="edit_nombre">Nombre completo</Label>
            <Input 
              id="edit_nombre" 
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej: María García" 
            />
          </div>
          <div>
            <Label htmlFor="edit_telefono">Teléfono</Label>
            <Input 
              id="edit_telefono" 
              value={tel}
              onChange={(e) => setTel(e.target.value)}
              placeholder="+52 55 1234 5678" 
            />
          </div>
          <div>
            <Label htmlFor="edit_estado">Estado</Label>
            <Select value={estado} onValueChange={setEstado}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="PENDIENTE">Pendiente</SelectItem>
                <SelectItem value="CONFIRMADO">Confirmado</SelectItem>
                <SelectItem value="RECHAZADO">Rechazado</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex justify-end space-x-2 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleSave}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Guardar Cambios
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
